export default __webpack_public_path__ + "Toy-Story-Movie-Cosmic_Toy.50ab4315.png";